<div class="card cardMeasurementProduct">
  <div class="card-title ms-3 mt-1" i18n>
    Scannen Sie einen Artikel, wenn eine EAN- oder GTIN-Nummer vorhanden ist
  </div>
  <div class="card-body">
    <input id="number" type="text" [(ngModel)]="code" class="form-control form-control" />
    <button
      type="button"
      kendoGridCellTemplate
      class="btn btn-success mb-2 mt-3"
      [asyncClick]="identify.bind(this)"
      [disabled]="identifyBtn.disabled"
      #identifyBtn="asyncClick"
      i18n
    >
      @if (identifyBtn.busy) { <span class="spinner-border spinner-border-sm me-1"></span> }
      Jetzt identifizieren
    </button>
  </div>
</div>
